"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.maxWidthUnframed = exports.maxWidthDesktopAnswer = exports.maxWidthDesktop = exports.maxWidthTabletAnswer = exports.maxWidthTablet = exports.maxWidthAnswer = exports.maxWidth = exports.tabletBreakpoint = exports.desktopBreakpoint = void 0;
var desktopBreakpoint = 928;
exports.desktopBreakpoint = desktopBreakpoint;
var tabletBreakpoint = 496; // iphone X as default width (could be smaller or bigger, but these +- 20 till 40px won't make a difference)

exports.tabletBreakpoint = tabletBreakpoint;
var maxWidth = 375;
exports.maxWidth = maxWidth;
var maxWidthAnswer = 155.5; // won't be exceeded in the build campaign

exports.maxWidthAnswer = maxWidthAnswer;
var maxWidthTablet = 448;
exports.maxWidthTablet = maxWidthTablet;
var maxWidthTabletAnswer = 216;
exports.maxWidthTabletAnswer = maxWidthTabletAnswer;
var maxWidthDesktop = 608;
exports.maxWidthDesktop = maxWidthDesktop;
var maxWidthDesktopAnswer = 216;
exports.maxWidthDesktopAnswer = maxWidthDesktopAnswer;
var maxWidthUnframed = 960;
exports.maxWidthUnframed = maxWidthUnframed;